import { HomesModule } from '~/store/modules/homes';
import { SearchModule } from '~/store/modules/search';
import { userIdDbRe } from '~common-helpers';
import { DevicesModule } from '~/store/modules/devices';
import { UserModule } from '~/store/modules/user';
import { OrderModule } from '~/store/modules/order';

export async function beforeUpdateAndEnter(to: any, from: any, next: any) {
    const { userIdentifier, homeId, gatewayId, moduleId, orderId } = to.params;
    let newSearch = null;
    if (userIdentifier) {
        const isUserId = userIdDbRe.test(userIdentifier);
        // check if we have a user (!userModule.id) or if current user is not the same as the userIdentifier
        // or if it is the same userIdentifier, check a search is needed if the previous user was an eliot user
        if (
            !UserModule.id
            || userIdentifier.toLowerCase() !== (isUserId ? UserModule.id : UserModule.prefixedUserMail.toLowerCase())
            || UserModule.isEliot
        ) {
            newSearch = {
                searchText: userIdentifier,
                paramType: isUserId ? 'user_id' : 'user_mail',
                fullParams: { userIdentifier, homeId, gatewayId, moduleId },
            };
        }
    } else if (homeId && !HomesModule.homes.find((home) => home.id === homeId)) {
        newSearch = {
            searchText: homeId,
            paramType: 'home_id',
            fullParams: { userIdentifier, homeId, gatewayId, moduleId },
        };
    } else if (gatewayId && !DevicesModule.devices.find((device) => device.id === gatewayId)) {
        newSearch = {
            searchText: gatewayId,
            paramType: 'device_id',
        };
    } else if (moduleId && !DevicesModule.devices.find((device) => device.id === moduleId)) {
        newSearch = {
            searchText: moduleId,
            paramType: 'module_id',
        };
    } else if (orderId && OrderModule.orderId !== orderId) {
        newSearch = {
            searchText: orderId,
            paramType: 'order_id',
        };
    }

    // if a newSearch object has been set, search
    if (newSearch) {
        await SearchModule.search(newSearch);
        next(false);

    // else we don't need to do another search, for example when we go from
    // /user/toto/home/homeid/gateway/id to
    // /user/toto/home/homeid, we don't need to do a search but we just need to set the current ids in our store
    } else {
        if (HomesModule.currentHomeId !== homeId) {
            HomesModule.setCurrentHomeId(homeId);
        }
        if (DevicesModule.currentGatewayId !== gatewayId) {
            DevicesModule.setCurrentGatewayId(gatewayId);
        }
        if (DevicesModule.currentModuleId !== moduleId) {
            DevicesModule.setCurrentModuleId(moduleId);
        }
        if (OrderModule.orderId !== orderId) {
            OrderModule.setOrderId(orderId);
        }
        if (userIdentifier) {
            // use encodeURIComponent to handle the prefixed users (e.g.: sdbg://...)
            to.params.userIdentifier = encodeURIComponent(userIdentifier);
        }
        next();
    }
}

export default {
    beforeUpdateAndEnter,
};
